// extracted by mini-css-extract-plugin
export default {"root":"+nbZr","pulsate":"Cwpp2"};